<template>
  <div class="organization-staff-info app-region blank-t-v blank-b-v blank-l-h blank-r-h">
    <a-form-model class="app-form" ref="form" :model="form" :rules="rules" :labelCol="$formLabelCol" :wrapperCol="$formWrapperCol">
      <a-form-model-item label="姓名" prop="name">
        <a-input v-model="form.name" placeholder="请输入姓名" allow-clear></a-input>
      </a-form-model-item>
      <a-form-model-item label="性别" prop="sex">
        <a-radio-group v-model="form.sex">
          <a-radio :value="1">男</a-radio>
          <a-radio :value="2">女</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="员工照片">
        <a-upload name="media" :show-upload-list="false" list-type="picture-card" :action="$uploadUrl" class="app-avatar-uploader" :before-upload="$beforeUpload" @change="handleChange">
          <dy-image :src="form.avatar" v-if="form.avatar" preview></dy-image>
          <a-icon :type="avatar.loading ? 'loading' : 'plus'" v-else></a-icon>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item label="手机" prop="phone">
        <a-input v-model="form.phone" placeholder="请输入手机" allow-clear></a-input>
      </a-form-model-item>
      <a-form-model-item label="工号" prop="jobNumber">
        <a-input v-model="form.jobNumber" placeholder="请输入工号" allow-clear></a-input>
      </a-form-model-item>
      <a-form-model-item label="部门" prop="department">
        <div>
          <a-button type="primary" @click="showModal">选择</a-button>
        </div>
        <div>
          <a-tag class="large" closable @close.prevent="delDepartment(index)" v-for="(value, index) in form.department" :key="index">{{value.name}}</a-tag>
        </div>
      </a-form-model-item>
      <a-form-model-item label="职位" prop="position">
        <a-input v-model="form.position" placeholder="请输入职位" allow-clear></a-input>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="$formEmptyLabelWrapperCol">
        <a-space>
          <a-button type="primary" @click="submit">提交</a-button>
          <a-button @click="cancel">取消</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
    <a-modal :title="modal.title" v-model="modal.show" @ok="confirmModal" destroy-on-close width="60%" centered>
      <tree-select v-model="modal.department" :data="tree.data" :params="tree.params" multiple></tree-select>
    </a-modal>
  </div>
</template>

<script>
  import OrganizationService from '@/io/organization.js';

  export default {
    name: 'OrganizationStaffInfo',
    data() {
      return {
        id: this.$route.params.id,
        tree: {
          data: [],
          params: {
            children: 'children',
            title: 'name',
            key: 'id'
          }
        },
        avatar: {
          loading: false
        },
        modal: {
          title: '选择部门',
          show: false,
          department: []
        },
        form: {
          name: null,
          sex: null,
          avatar: null,
          phone: null,
          jobNumber: null,
          department: [],
          position: null
        },
        rules: {
          name: [
            {
              required: true,
              message: '请填写姓名'
            }
          ],
          sex: [
            {
              required: true,
              message: '请选择性别'
            }
          ],
          phone: [
            {
              required: true,
              message: '请填写手机'
            }
          ],
          department: [
            {
              required: true,
              message: '请选择部门'
            }
          ]
        }
      }
    },
    mounted () {
      this.initTreeData().then(() => {
        this.initPage();
      });
    },
    methods: {
      initPage() {
        if (this.id) {
          OrganizationService.staffInfo(this.id).then(res => {
            this.form.name = res.name;
            this.form.sex = res.sex;
            this.form.avatar = res.image_url;
            this.form.phone = res.phone_number;
            this.form.jobNumber = res.job_number;
            this.form.department = res.tissue;
            this.form.position = res.position;
          }).catch(err => {});
        }
      },
      initTreeData() {
        return OrganizationService.companyList().then(res => {
          this.tree.data = res;
        }).catch(err => {});
      },
      handleChange(info) {
        let status = info.file.status;
        if (status) {
          if (status === 'done') {
            this.avatar.loading = false;
            this.form.avatar = info.file.response.media;
          } else {
            this.avatar.loading = true;
          }
        }
      },
      delDepartment(index) {
        this.form.department.splice(index, 1);
      },
      showModal() {
        this.modal.show = true;
        this.modal.department = this.$createNewVariable(this.form.department);
      },
      confirmModal() {
        this.modal.show = false;
        this.form.department = this.$createNewVariable(this.modal.department);
      },
      submit() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          if (this.id) {
            OrganizationService.editStaff(
              this.id,
              this.form.name,
              this.form.sex,
              this.form.avatar,
              this.form.phone,
              this.form.jobNumber,
              this.form.department.map(val => val[this.tree.params.key]),
              this.form.position
            ).then(res => {
              this.$afterFormSubmit('编辑成功', () => {
                this.cancel();
              });
            }).catch(err => {});
          } else {
            OrganizationService.addStaff(
              this.form.name,
              this.form.sex,
              this.form.avatar,
              this.form.phone,
              this.form.jobNumber,
              this.form.department.map(val => val[this.tree.params.key]),
              this.form.position
            ).then(res => {
              this.$afterFormSubmit('创建成功', () => {
                this.cancel();
              });
            }).catch(err => {});
          }
        });
      },
      cancel() {
        this.$router.push('/platform/organization_manage');
      }
    },
  }
</script>

<style lang="less" scoped>

</style>